import Commons from '../shared/libraries/commons';
import { Countries } from '../shared/libraries/countries';
import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class CustomerSerializer extends BaseSerializer {
  deserialize(raw) {
    const serverRes = raw.data || raw.error;
    const success = serverRes.statusCode == 200 || serverRes.statusCode == 404;
    if (success) {
      return {
        statuCode: 200,
        success: true,
        message: 'List got',
        data: (serverRes?.data || []).map(formatCustomer)
      };
    }
    return {
      statusCode: serverRes.statusCode || raw.status || 500,
      success: false,
      message:
        (serverRes.message || 'Erreur lors de la récupération') +
        ` Code d'erreur: CUS_ERR_${
          serverRes.statusCode || raw.status || '1000'
        }`,
      data: null
    };
  }

  serialize() {}

  deserializeTransactoinDetail(raw) {
    const serverRes = raw.data || raw.error;
    const success = serverRes.statusCode == 200 || serverRes.statusCode == 404;
    if (!success) {
      return {
        statusCode: serverRes.statusCode || raw.status || 500,
        success: false,
        message:
          (serverRes.message || 'Erreur lors de la récupération') +
          ` Code d'erreur: CUS_ERR_${
            serverRes.statusCode || raw.status || '1000'
          }`,
        data: null
      };
    }

    return {
      statuCode: 200,
      success: true,
      message: 'Found',
      data: formatCustomer(serverRes.data)
    };
  }
}

function formatCustomer(raw) {
  return {
    email: raw.email,
    countryCode: raw.countryCode,
    createdAt: raw.createdAt,
    firstName: raw.firstName,
    id: raw.id,
    lastName: raw.lastName,
    phoneNumber: raw.phoneNumber,
    updatedAt: raw.updatedAt,
    cretionDate: Commons.time(raw.createdAt, 'DD MMM YYYY - hh:mm'),
    country: Countries.find(raw.countryCode)
  };
}

export const serializer = new CustomerSerializer();
